(ns iris.data.firebase-impl
  "Firebase implementation of IDataSource protocol.
   
   This wraps existing firebase.cljs functions to implement the protocol."
  (:require
   [iris.data.protocol :as proto]
   [iris.firebase :as fb]
   [iris.globals :as globals]))

(defrecord FirebaseDataSource []
  proto/IDataSource
  
  ;; Raids
  (set-raid2eid [this abbr eid]
    (fb/set-raid2eid abbr eid))
  
  (get-raid2eid [this abbr]
    (fb/get-raid2eid abbr))
  
  (get-eid2raid [this eid]
    (fb/get-eid2raid eid))
  
  (reset-eid2raid [this]
    (fb/reset-eid2raid))
  
  (reset-raid2eid [this]
    (fb/reset-raid2eid))
  
  (reset-raid-cache-id [this]
    (fb/reset-raid-cache-id))
  
  ;; Votes
  (get-post-votes [this ws forum thread nick on-update-handler]
    (fb/get-post-votes ws forum thread nick on-update-handler))
  
  (get-post-votes-promise [this ws forum thread nick]
    (fb/<p-get-post-votes ws forum thread nick))
  
  ;; Replies
  (get-replies [this ws thread on-update-handler]
    (fb/get-replies ws thread on-update-handler))
  
  (get-replies-promise [this ws thread]
    (fb/<p-get-replies ws thread))
  
  (get-replies-t-promise [this ws thread]
    (fb/<p-get-replies-t ws thread))
  
  ;; Shares
  (get-shares-promise [this ws share-page-kind ruid]
    (fb/<p-get-shares ws share-page-kind ruid))
  
  ;; Admin - Votes & Shares Logs
  (push-admin-votes-log [this data]
    (fb/push-admin-votes-log data))
  
  (push-admin-shares-log [this data]
    (fb/push-admin-shares-log data))
  
  ;; Thread Alerts
  (set-thread-follow [this data]
    (fb/set-thread-follow data))
  
  (remove-thread-follow [this id]
    (fb/remove-thread-follow id))
  
  (set-thread-follow-t [this id t]
    (fb/set-thread-follow-t id t))
  
  (get-thread-follow-promise [this id]
    (fb/<p-get-thread-follow id))
  
  (get-all-thread-follow-promise [this uid]
    (fb/<p-get-all-thread-follow uid))
  
  ;; User Defaults
  (set-defaults-ws [this ws]
    (fb/set-defaults-ws ws))
  
  (get-defaults-ws-promise [this]
    (fb/<p-get-defaults-ws))
  
  (get-default-ws-with-fallback [this default]
    (fb/get-default-ws default))
  
  ;; User Actions
  (set-last-action [this data]
    (fb/set-last-action data))
  
  ;; Moderation Logs
  (push-admin-all-moderation-log [this data]
    (fb/push-admin-all-moderation-log data))
  
  (push-admin-moderation-log [this data]
    (fb/push-admin-moderation-log data))
  
  (get-admin-moderation-logs-promise [this ws uid]
    (fb/<p-get-admin-moderation-logs ws uid))
  
  (get-admin-all-moderation-logs-promise [this ws ruid]
    (fb/<p-get-admin-all-moderation-logs ws ruid)))

(defn create-firebase-datasource
  "Create a new Firebase data source"
  []
  (->FirebaseDataSource))
